import PropTypes from "prop-types"


const DistributionShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  isApproved: PropTypes.bool.isRequired,
  investmentId: PropTypes.string.isRequired,
  transactionIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  investorAccountId: PropTypes.string.isRequired,
})

export default DistributionShape
